import { GameObject } from '../base/GameObject';
import { Earth } from '../earth/Earth';
import Phaser from 'phaser';
import { Monster } from '../monsters/Monster';

export abstract class Boss extends Monster {
  // protected speed: number;
  // protected reward: number;
  // protected specialAbility: string;
  // protected targetEarth: Earth | null = null;
  protected lastAbilityTime: number = 0;
  protected abilityCooldown: number = 5000; // 5 seconds

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.speed = 20;
    this.reward = 100;
    this.specialAbility = '';
  }

  override update(time: number, delta: number): void {
    if (!this.scene) return;
    // Find Earth if not found
    if (!this.targetEarth) {
      this.findEarth();
    }

    // Move towards Earth
    if (this.targetEarth) {
      this.move();
      this.useAbility(time);
    }
  }

  override attackEarth(): void {
    if (!this.targetEarth) return;

    // Deal heavy damage to Earth
    if (this.isActive) this.targetEarth.takeDamage(30);

    // Destroy boss
    this.destroy();
  }

  protected useAbility(time: number): void {
    if (time - this.lastAbilityTime > this.abilityCooldown) {
      this.activateAbility();
      this.lastAbilityTime = time;
    }
  }

  // abstract activateAbility(): void;

  override takeDamage(amount: number): void {
    super.takeDamage(amount);

    // Visual feedback for boss
    this.showDamageEffect();
  }

  protected showDamageEffect(): void {
    // Visual feedback - change color temporarily
    const circle = this.getByName('bossCircle');
    const originalColor = 0xff0000;
    const flashColor = 0xffffff;
    if (circle instanceof Phaser.GameObjects.Graphics) {

      circle.clear();
      circle.fillStyle(flashColor);
      circle.fillCircle(0, 0, 20);

      // Restore original color after 200ms
      this.scene.time.delayedCall(200, () => {
        circle.clear();
        circle.fillStyle(originalColor);
        circle.fillCircle(0, 0, 20);
      });
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(flashColor);
      this.scene.time.delayedCall(200, () => {
        circle.setFillStyle(originalColor);
      });
    }
  }

  protected showAbilityEffect(tintColor: number): void {
    // Visual effect for ability activation
    const circle = this.getByName('bossCircle');
    const originalColor = 0xff0000;
    if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(tintColor);
      circle.fillCircle(0, 0, 20);

      // Restore original color after ability duration
      this.scene.time.delayedCall(3000, () => {
        circle.clear();
        circle.fillStyle(originalColor);
        circle.fillCircle(0, 0, 20);
      });
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(tintColor);
      this.scene.time.delayedCall(3000, () => {
        circle.setFillStyle(originalColor);
      });
    }
  }

  // Getters for external access
  // getSpeed(): number {
  //   return this.speed;
  // }

  // getReward(): number {
  //   return this.reward;
  // }

  // getSpecialAbility(): string {
  //   return this.specialAbility;
  // }
  
  // public getIsActive(): boolean {
  //   return this.isActive;
  // }
} 